<template>
    <div class="layout-letter-side-bar">
        <p v-for="letter in recordLetterList" v-bind:key="letter" @click.stop="clickLetter(letter)">{{letter}}</p>
    </div>
</template>

<script>
import { RECORD_DATA_MANAGER } from '../../modules/data/manager/recorddatamng'
export default {
    name: 'LetterSideBar',
    computed: {
        recordList() {
            return this.$store.state.record.recordListData;
        },
        recordLetterList() {
            return this.$store.state.recordletter.recordLetterList;
        },
    },
    methods:{
        clickLetter(letter) {
            var firstLIndex = RECORD_DATA_MANAGER.getRecordDataIndexByFirstL(this.recordList, letter);
                firstLIndex = firstLIndex == -1 ? 0 : firstLIndex;
            console.log('clickLetter', firstLIndex);
            this.$store.state.recordletter.recordCurFirstL = letter;
            this.$bus.emit('updateScrollByLetter', firstLIndex)
            // this.$store.state.recordletter.scrollToIndex = firstLIndex;
        }
    }
}
</script>